<template>
  <NoneData v-if="!anchorList.length" style="background: #ffffff" propsText="该店铺所选时段内无关联达人信息" :height="6" />
  <div id="anchor" v-else>
    <div class="carrier-list-data">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多数据了哦~"  @load="getTableData">
        <router-link v-for="(item, index) in anchorList.slice(0, params.pageNum * 25)" :key="index" :to="`/anchor/${item.anchor.id}?banner=2`" class="item-default">
          <div class="commodity-sort">{{ index + 1 }}</div>
          <div class="item-icon icon-radius">
            <img :src="$_.get(item, 'anchor.avatar')" alt="avatar">
          </div>
          <div class="center-anchor-goods">
            <div class="item-name">{{ $_.get(item, 'anchor.name') }}</div>
            <div class="item-fans">{{ $retainWan($_.get(item, 'anchor.fans')) }}粉丝</div>
  <!--          <div class="item-tag-contain">-->
  <!--            <div class="default-tag" v-for="tag of item.commodityCategory" :key="tag">{{ tag }}</div>-->
  <!--          </div>-->
          </div>
          <div class="data-for-detail">
            <div class="data-title">关联销售额</div>
            <div class="data-number data-number-red">¥{{ $retainWan(item.sales) }}</div>
            <div class="data-title data-title-sec">关联销量</div>
            <div class="data-number">{{ $retainWan(item.salesVolume) }}</div>
          </div>
        </router-link>
      </van-list>
    </div>
  </div>
</template>

<script>

export default {
  props: { query:Object},
  data() {
    return {
      params:{
        pageNum:1,
        pageSize:10,
        order:'desc',
        sort:'sales'
      },
      anchorList:[],
      loading:true,
      count:0,
    }
  },
  watch:{
    query:{
      deep:true,
      immediate:true,
      handler(){
        this.params.pageNum = 1
        this.params = {
          ...this.params,
          ...this.$props.query
        }
        this.anchorList = []
        this.getTableData()
      }
    }
  },
  computed:{
    finished:( _this = this) => ( _this.count === _this.anchorList.length )
  },
  methods: {
    async getTableData(){
      const res = await this.$api.get(`/v2/shop/${this.$route.params.id}/anchorStatistic`,{params:this.params}).catch(_=>{})
      if(res.data.data){
        // 如果页码等于一  第一次加载或更换日期
        this.anchorList = this.params.pageNum === 1 ? res.data.data :  this.anchorList.concat(res.data.data)
        this.params.pageNum++
        this.count = res?.data?.paging?.count || 0
        this.loading = false
      }
    },
  },

}
</script>

<style scoped>
.loading {
  font-size: 0.24rem;
  color: #fbfafa;
  padding: 0.5rem 0.3rem;
  text-align: center;
}
</style>
